<script>
export default {
  name: 'AppTableColumn',
  inject: ['$table'],
  props: {
    header: {
      type: String,
      default: '',
    },
    visible: {
      type: Boolean,
      default: true,
    },
    sortBy: {
      type: Object,
      validator: (sortBy) => !sortBy.field || [null, 'desc', 'asc'].includes(sortBy.direction),
    },
    name: {
      type: String,
      default: '',
    },
    cellClasses: {
      type: [String, Object, Array],
      default: '',
    },
    colClasses: {
      type: [String, Object, Array],
      default: '',
    },
    headerClasses: {
      type: [String, Object, Array],
      default: '',
    },
    headerTooltip: {
      type: String,
      default: '',
    },
    headerTooltipType: {
      type: String,
      default: 'info',
    },
    headerTooltipSize: {
      type: Number,
      default: 16,
    },
    headerTooltipClasses: {
      type: String,
      default: null,
    },
    headerDropdown: {
      type: Boolean,
      default: false,
    },
    headerDropdownExtraClasses: {
      type: String,
      default: '',
    },
    headerDropdownFields: {
      type: Object,
      default: () => ({}),
    },
    headerDropdownComponent: {
      type: String,
      default: '',
    },
  },
  created() {
    this.$table.registerColumn(this);
  },
  render() {
    return null;
  },
};
</script>
